import { AppConfig } from "src/app/configs/app-config";
import { LocalStorageService } from '../../../core/services/local-storage/local-storage.service';


export class SalarioConyuge {
    constructor() {}

    public static obtenerSalarioConyuge(localStorageService:LocalStorageService) {

      const salarioMinimoDeterminado = AppConfig.salarioMinimo();
      const salarioBase = this.obtenerSalarioIntegral(localStorageService);

      return {
        // Integral
        "01": {
          salarioMinimo: salarioBase,
          salarioMaximo: undefined,
        },
        // Fijo
        "02": {
          salarioMinimo: salarioMinimoDeterminado,
          salarioMaximo: salarioBase-1,
        },
      };
    }

    public static obtenerSalarioIntegral(localStorageService: LocalStorageService) {


      const salarioMinimoDeterminado = AppConfig.salarioMinimo();
      return Number((salarioMinimoDeterminado * 10)+(salarioMinimoDeterminado * 10)*0.3);
    }
  }
